export const environment = {
  production: true,
  environment: 'prod',
  auth: {
      clientId: '1ba7ca51-bc37-4db2-87cf-a83a1d595715',
      authority: 'https://login.microsoftonline.com/76b5b304-4736-44dc-ba8c-944e061047eb',
      redirectUri: 'https://ts.dnv.org/',
      postLogoutRedirectUri: 'https://ts.dnv.org/',
  }
};
